export type SprintUserTimeOffType = "PTO" | "HOLIDAY" | "SICK";

export interface SprintUserTimeOffEntry {
  /** ISO date `YYYY-MM-DD` */
  date: string;
  hours: number;
  timeOffType: SprintUserTimeOffType;
  comments?: string | null;
}

const VALID_TIME_OFF_TYPES: SprintUserTimeOffType[] = [
  "PTO",
  "HOLIDAY",
  "SICK",
];

export function SprintUserTimeOffEntryFromJSON(
  json: Record<string, any>,
): SprintUserTimeOffEntry {
  return {
    date: typeof json["date"] === "string" ? json["date"] : "",
    hours: typeof json["hours"] === "number" ? json["hours"] : 0,
    timeOffType: VALID_TIME_OFF_TYPES.includes(json["timeOffType"])
      ? json["timeOffType"]
      : "PTO",
    comments: json["comments"] ?? null,
  };
}
